/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Status_QueuedInputs */

const cs_jobs_status_queued = /** @type {(inputs: Jobs_Status_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ve frontě`)
};

const en_jobs_status_queued = /** @type {(inputs: Jobs_Status_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queued`)
};

/**
* | output |
* | --- |
* | "Queued" |
*
* @param {Jobs_Status_QueuedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const jobs_status_queued = /** @type {((inputs?: Jobs_Status_QueuedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Status_QueuedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_status_queued(inputs)
	return cs_jobs_status_queued(inputs)
});